import { isValid } from 'date-fns';

// Take the month, day, and year of what is entered, and set the time to UTC Midnight.
// Example, user entered May 13th, 2021 in California where it currently 10:00:00.
// We will be saving it as May 13th, 2021 at 00:00:00 UTC Time.
// Old code converted date to midnight for the user's local timezone which caused timezone issues and incorrect dates to display
export function getUTCTimeFromDateString(dateString: string) {
  if (!dateString) {
    return null;
  }

  // Use native Date parsing like property-condition-web does
  // This handles various formats including "January 15, 2024", "01/15/2024", ISO strings, etc.
  const date = new Date(dateString);

  // Check if the parsed date is valid
  if (!isValid(date)) {
    // eslint-disable-next-line no-console
    console.error(`Invalid date string: "${dateString}" could not be parsed`);
    return null;
  }

  date.setUTCHours(0, 0, 0, 0);
  return date.getTime().toString();
}
